import moment from 'moment';
import { RoleAccess } from 'types/user-profile';
import i18n from "utils/i18n";

interface idLabel { id: string, label: string };
export const formatCurrency = (number: number, maxNumAfter: number = 0) => {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: maxNumAfter })
        .format(number)
        .replace('$', '');
};

export const getTimeTodo = (valDate: string, format: string = 'll'): string => {
    let closeDate = '';
    if (valDate) {
        closeDate = moment(valDate.toString().trim()).format(format);
    }
    return closeDate;
};
export const sumValueArray = (array: any, key: string) => {
    let total = 0;
    for (var i = 0, _len = array.length; i < _len; i++) {
        total += array[i][key];
    }
    return total;
};
// Function to convert from 1,000 to 1000
export const removeComma = (number: string) => {
    return parseInt(number.split(',').join(''));
};

// format current date | if not have date return curre
export const formatDate = (format: string = 'DD/MM/YYYY HH:mm', date: any = new Date()) => {
    if (format === '') format = 'DD/MM/YYYY HH:mm';
    if (!date) date = new Date();
    return moment(date).format(format);
};
export const formatDate2 = (str: string) => {
    const date = new Date(str),
        mnth = ("0" + (date.getMonth() + 1)).slice(-2),
        day = ("0" + date.getDate()).slice(-2);
    const hours = ("0" + date.getHours()).slice(-2);
    const minutes = ("0" + date.getMinutes()).slice(-2);
    const seconds = ("0" + date.getSeconds()).slice(-2);
    const year = date.getFullYear();
    return `${year}/${mnth}/${day} ${hours}:${minutes}:${seconds}`
};

export const objectToAutocomplete = (obj: any) => {
    if (obj) {
        return Object.keys(obj)
            .sort((a, b) => a.localeCompare(b))  // Sort the keys alphabetically
            .map((keyName, index: number) => ({
                id: keyName,
                label: obj[keyName],
            }));
    }
    return [null, null];
};
export const objectFilterKeyAutocomplete = (obj: any, key: string) => {
    if (obj && key != "" && typeof obj[key] != "undefined") {
        return {
            id: key,
            label: obj[key],
        }
    }
    return null;
};
export const findUserFromArray = (array: any, keyCompare: string, key: string): idLabel | null => {
    const arr_find = array.find((item: any) => item[keyCompare] === key);
    if (!arr_find) return null;
    return {
        id: arr_find.id,
        label: arr_find.user_name,
    }
};
// set cookie
export const setCookie = (name: string, value: string, days: number, path: string = "/") => {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=" + path;
};
// get cookie
export const getCookie = (name: string) => {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
};

export const deleteCookie = (name: string) => {
    document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    return true;
};

export const checkMediaType = (fileName: string): boolean => {
    const imageExtensions: string[] = ['.png', '.jpg', '.jpeg', '.gif'];
    const videoExtensions: string[] = ['.mpg', '.mp2', '.mpeg', '.mpe', '.mpv', '.mp4'];
    if (imageExtensions.some(ext => fileName?.endsWith(ext))) {
        return true;
    }
    if (videoExtensions.some(ext => fileName?.endsWith(ext))) {
        return false;
    }
    return true;
}
export const removeValueByArray = (arr: string[], val: string) => {
    const indexToDelete = arr.indexOf(val);
    if (indexToDelete > -1) {
        arr.splice(indexToDelete, 1);
    }
    return arr;
}
export const inArray = (arr: any[], id: number) => {
    return arr.indexOf(id) != -1;
}

export const getGender = (genderId: string) => {
    switch (genderId) {
        case "0":
            return i18n.t("Male");
        case "1":
            return i18n.t("Female");
        default:
            return i18n.t("Other");
    }
}

export const getPositionUser = (id: string) => {
    const positions = [
        i18n.t("Leader"),
        i18n.t("Staff"),
        i18n.t("CEO"),
        i18n.t("HR/GA Director"),
        i18n.t("HR Manager"),
        i18n.t("Admin Manager"),
        i18n.t("Tenant Manager"),
        i18n.t("Marketing Manager"),
        i18n.t("General MD Director"),
        i18n.t("FMCG MD Manager"),
        i18n.t("Key in Manager"),
        i18n.t("Fashion MD Manager"),
        i18n.t("Non food MD Manager"),
        i18n.t("Fresh Food MD Director"),
        i18n.t("Finance Director"),
        i18n.t("Expansion Director"),
    ];
    return positions[parseInt(id)] ?? "";
}

export const rUserCheck = (listRole: any, nameRole: string): RoleAccess => {
    return {
        add: listRole?.[nameRole]?.add || false,
        edit: listRole?.[nameRole]?.edit || false,
        delete: listRole?.[nameRole]?.delete || false,
        read: listRole?.[nameRole]?.read || false,
        report: listRole?.[nameRole]?.report || false,
        other: listRole?.[nameRole]?.other || false
    };
}

export const removeNullUndefined = (obj = {}) => Object.fromEntries(Object.entries(obj).filter(([_, v]) => v !== undefined));// && v != "-1"

export const validateMessage = (message: string = "", type: string = "required") => {
    message = i18n.t(message);
    switch (type) {
        case "required":
            return `${i18n.t('_is_required_before')}${message}${i18n.t('_is_required_after')}`;
        case "format":
            return `${i18n.t('_invalid_format_before')}${message}${i18n.t('_invalid_format_after')}`;
        default:
            return `${i18n.t('_is_required_before')}${message}${i18n.t('_is_required_after')}`;
    }
}